import { autorun, makeAutoObservable } from 'mobx';
import get from 'lodash/get';
import set from 'lodash/set';
import omit from 'lodash/omit';
import assignIn from 'lodash/assignIn';
import Customer from './Customer';
import StoreAuth from './StoreAuth';
import { findString, isEqualText } from '@Utils/String';
import { defaults } from '@Utils/Utils';
import { language } from '@Language';
class StoreUser {

    userData = null
    located = null
    commission = null
    lsb = null
    acl = null
    currentProfileData = null

    constructor() {
        makeAutoObservable(this)
        autorun((reaction) => {
            if (get(this.userData, 'id.unicity', null) !== get(this.currentProfileData, 'id.unicity', null)) {
                this.currentProfileData = new Customer(this.userData)
                reaction.dispose()
            }
        })
    }
    /** 
     * @returns {Customer} Customer
     */
    CustomerData() {
        
        if (this.currentProfileData) {
            return this.currentProfileData
        } else {
            this.currentProfileData = new Customer(this.userData)
        }

        return this.currentProfileData
    }

    Acl() {
        return this.userData.acl
    }

    setUserData(value) {
        if (value.profile.id) {
            this.userData = value.profile
            this.commission = value.commission
            this.lsb = value.lsb
            this.located = value.located
        }
    }

    Reset() {
        this.userData = null
        this.located = null
        this.commission = null
        this.lsb = null
    }
    
    getUserData() {
        const data = get(this.CustomerData(), 'userData', {})
        const omitedData = omit(data, [
            'achievementsHistory', 'acl', 'cumulativeMetricsProfile', 'employmentDetails',
            'email', 'href', 'homePhone', 'humanName', 'id', 'joinDate', 'mainAddress', 
            'metricsProfileHistory', 'mobilePhone', 'profilePicture', 'status', 'type'
        ])

        const result = data ? {
            achievementsHistory: get(data, 'achievementsHistory'),
            acl: get(data, 'acl'),
            cumulativeMetricsProfile: get(data, 'cumulativeMetricsProfile'),
            employmentDetails: get(data, 'employmentDetails'),
            email: get(data, 'email'),
            href: get(data, 'href'),
            homePhone: get(data, 'homePhone'),
            humanName: get(data, 'humanName'),
            id: get(data, 'id'),
            joinDate: get(data, 'joinDate'),
            mainAddress: get(data, 'mainAddress'),
            metricsProfileHistory: get(data, 'metricsProfileHistory'),
            mobilePhone: get(data, 'mobilePhone'),
            profilePicture: get(data, 'profilePicture'),
            status: get(data, 'status'),
            type: get(data, 'type')
        } : {}

        if (omitedData) {
            assignIn(result, omitedData)
        }

        return result
    }

    getHref() {
        return this.getUserData().href
    }

    getEmail() {
        return this.getUserData().email
    }

    getHumanName() {
        const human = this.getUserData().humanName
        const data = {
            english: get(human, 'fullName', ''),
            native: ''
        }
        assignIn(data, human)

        let native = ''
        Object.keys(human).map((key) => {
            if (findString(key, '@') === true) {
                native = human[key]
            }
        })

        if (native) {
            set(data, 'native', native)
        }

        return data
    }

    getName(translate = true, fallback = true) {
        const human = this.getHumanName()
        if (language.isNative() && translate === true) {
            if (human.native) {
                return human.native
            } else if (fallback) {
                return human.english
            } else {
                return ''
            }
        } else {
            return human.english
        }
    }

    getNameEnglish() {
        return this.getHumanName().english
    }

    getNameNative() {
        return this.getHumanName().native
    }

    getMainAddress() {
        return this.getUserData().mainAddress
    }

    getMobile() {
        return this.getUserData().mobilePhone
    }

    getShortStatus() {
        return defaults(this.isStatusL() ? 'L' : StoreAuth.ShortStatus(), 'C')
    }

    getStatus() {
        return this.getUserData().status
    }

    getType() {
        return this.getUserData().type
    }

    getID() {
        return StoreAuth.id
    }

    getEntryPeriod() {
        return this.getUserData().entryPeriod
    }

    getJoinDate() {
        return this.getUserData().joinDate
    }

    isStatusE() {
        return StoreAuth.ShortStatus() === 'E' && this.isStatusL() === false
    }

    isStatusL() {
        return isEqualText(get(this.getUserData(), 'employmentDetails.employerName', ''), 'Performance Labs')
    }

    isEnabledPV() {
        return StoreAuth.IsShowPv()
    }

    isStatusP() {
        return StoreAuth.ShortStatus() === 'P' 
    }

    setProfilePicture(response) {
        this.userData.profilePicture = response
    }
}



export default new StoreUser()